import * as r from "react";
import { P as h, c as y, e as U } from "./index-wif4gfZf.js";
import { u as T } from "./index-DLcqcWxM.js";
import { u as b } from "./index-0ioNhtNM.js";
import { j as P } from "./utils-BdNIfrGQ.js";
import j from "react-dom";
import { u as z } from "./index-CCKe-Mpx.js";
function H(n, e = globalThis?.document) {
  const t = b(n);
  r.useEffect(() => {
    const o = (s) => {
      s.key === "Escape" && t(s);
    };
    return e.addEventListener("keydown", o, { capture: !0 }), () => e.removeEventListener("keydown", o, { capture: !0 });
  }, [t, e]);
}
var K = "DismissableLayer", m = "dismissableLayer.update", X = "dismissableLayer.pointerDownOutside", Y = "dismissableLayer.focusOutside", w, x = r.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), B = r.forwardRef(
  (n, e) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      onFocusOutside: a,
      onInteractOutside: d,
      onDismiss: l,
      ...E
    } = n, c = r.useContext(x), [u, S] = r.useState(null), f = u?.ownerDocument ?? globalThis?.document, [, A] = r.useState({}), N = T(e, (i) => S(i)), D = Array.from(c.layers), [W] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), _ = D.indexOf(W), O = u ? D.indexOf(u) : -1, k = c.layersWithOutsidePointerEventsDisabled.size > 0, L = O >= _, M = G((i) => {
      const v = i.target, R = [...c.branches].some((p) => p.contains(v));
      !L || R || (s?.(i), d?.(i), i.defaultPrevented || l?.());
    }, f), C = J((i) => {
      const v = i.target;
      [...c.branches].some((p) => p.contains(v)) || (a?.(i), d?.(i), i.defaultPrevented || l?.());
    }, f);
    return H((i) => {
      O === c.layers.size - 1 && (o?.(i), !i.defaultPrevented && l && (i.preventDefault(), l()));
    }, f), r.useEffect(() => {
      if (u)
        return t && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (w = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), g(), () => {
          t && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = w);
        };
    }, [u, f, t, c]), r.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), g());
    }, [u, c]), r.useEffect(() => {
      const i = () => A({});
      return document.addEventListener(m, i), () => document.removeEventListener(m, i);
    }, []), /* @__PURE__ */ P.jsx(
      h.div,
      {
        ...E,
        ref: N,
        style: {
          pointerEvents: k ? L ? "auto" : "none" : void 0,
          ...n.style
        },
        onFocusCapture: y(n.onFocusCapture, C.onFocusCapture),
        onBlurCapture: y(n.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: y(
          n.onPointerDownCapture,
          M.onPointerDownCapture
        )
      }
    );
  }
);
B.displayName = K;
var q = "DismissableLayerBranch", F = r.forwardRef((n, e) => {
  const t = r.useContext(x), o = r.useRef(null), s = T(e, o);
  return r.useEffect(() => {
    const a = o.current;
    if (a)
      return t.branches.add(a), () => {
        t.branches.delete(a);
      };
  }, [t.branches]), /* @__PURE__ */ P.jsx(h.div, { ...n, ref: s });
});
F.displayName = q;
function G(n, e = globalThis?.document) {
  const t = b(n), o = r.useRef(!1), s = r.useRef(() => {
  });
  return r.useEffect(() => {
    const a = (l) => {
      if (l.target && !o.current) {
        let E = function() {
          I(
            X,
            t,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: l };
        l.pointerType === "touch" ? (e.removeEventListener("click", s.current), s.current = E, e.addEventListener("click", s.current, { once: !0 })) : E();
      } else
        e.removeEventListener("click", s.current);
      o.current = !1;
    }, d = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(d), e.removeEventListener("pointerdown", a), e.removeEventListener("click", s.current);
    };
  }, [e, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function J(n, e = globalThis?.document) {
  const t = b(n), o = r.useRef(!1);
  return r.useEffect(() => {
    const s = (a) => {
      a.target && !o.current && I(Y, t, { originalEvent: a }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", s), () => e.removeEventListener("focusin", s);
  }, [e, t]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function g() {
  const n = new CustomEvent(m);
  document.dispatchEvent(n);
}
function I(n, e, t, { discrete: o }) {
  const s = t.originalEvent.target, a = new CustomEvent(n, { bubbles: !1, cancelable: !0, detail: t });
  e && s.addEventListener(n, e, { once: !0 }), o ? U(s, a) : s.dispatchEvent(a);
}
var re = B, oe = F, Q = "Portal", V = r.forwardRef((n, e) => {
  const { container: t, ...o } = n, [s, a] = r.useState(!1);
  z(() => a(!0), []);
  const d = t || s && globalThis?.document?.body;
  return d ? j.createPortal(/* @__PURE__ */ P.jsx(h.div, { ...o, ref: e }), d) : null;
});
V.displayName = Q;
export {
  oe as B,
  B as D,
  V as P,
  re as R
};
